export enum PhxFormControlLayoutType {
    Inline = 1,
    Stacked = 2,
    Responsive = 3,
    InputOnly = 4,
    Mobile = 5
}
